module.exports = __webpack_public_path__ + "olm.35f4ef0.wasm";